import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import Button from './Button';

import componentHeader from '../styles/componentheader';

class HeaderComponent extends Component {
    static propTypes = {
        children: PropTypes.node,
        title: PropTypes.string,
        buttonGroup: PropTypes.node,
        label: PropTypes.string,
        link: PropTypes.string,
        onclick: PropTypes.func,
        titleAddition: PropTypes.string,
        t: PropTypes.func.isRequired,
    }

    renderTitleAddition() {
        if (!this.props.titleAddition) return null;

        return (<span className={componentHeader.addition}>{this.props.titleAddition}</span>);
    }

    renderButton() {
        if (this.props.buttonGroup) return this.props.buttonGroup;

        if (!this.props.link && !this.props.onclick) return null;

        const label = this.props.t(this.props.label || 'common:seeAll');

        return (
            <div className={componentHeader.buttons}>
                <Button
                    label={label}
                    link={this.props.link}
                    onClick={this.props.onclick}
                />
            </div>
        );
    }

    render() {
        const { t } = this.props;

        return (
            <div className={componentHeader.container}>
                <div className={componentHeader.titleWrapper}>
                    <h2 className={componentHeader.title}>
                        {t(this.props.title)}
                        {this.renderTitleAddition()}
                    </h2>
                    {this.renderButton()}
                </div>
                {this.props.children}
            </div>
        );
    }
}

export default translate('menu')(HeaderComponent);



/** WEBPACK FOOTER **
 ** /src/shared/components/HeaderComponent.js
 **/